import { getImageInfoFromUrl } from '@/components/Uploader/utils'
import { isNumber } from '@/utils/utils'
const transRatio = ratio => {
    if (!ratio) {
        return null
    }

    if (Array.isArray(ratio)) {
        return ratio[0]
    }

    return ratio
}

// 计算符合这个比例的正整数
const adjustImageRatio = ({ originalWidth, originalHeight, targetRatio }) => {
    let newWidth = originalWidth
    let newHeight = originalHeight

    while (newWidth / newHeight !== targetRatio) {
        if (newWidth / newHeight > targetRatio) {
            newWidth--
        } else {
            newHeight--
        }
    }

    return { width: newWidth, height: newHeight }
}

// 服务端最大宽度、高度支持16384px 前端设置最大宽度15000px 保证功能能正常使用
const MAX_WIDTH_VALUE = 15000
const MAX_HEIGHT_VALUE = 15000

// eslint-disable-next-line complexity
export default ({ url, validatorParam }) => {
    const ratio = transRatio(validatorParam?.ratioValidator?.ratio)
    const rectValidator = validatorParam?.rectValidator
    const minHeight = rectValidator?.minHeight || rectValidator?.minRepairHeight
    const maxHeight = rectValidator?.maxHeight || rectValidator?.maxRepairHeight
    const minWidth = rectValidator?.minWidth || rectValidator?.minRepairWidth
    const maxWidth = rectValidator?.maxWidth || rectValidator?.maxRepairWidth

    const { height, width } = getImageInfoFromUrl(url)
    let imgMaxWidth = Math.max(height, width)
    let imgMaxHeight = null

    // 先根据比例计算宽度，3/4的情况，要保证转换的宽度没问题
    if (isNumber(ratio)) {
        imgMaxWidth = imgMaxWidth * ratio
    }

    if (isNumber(minWidth) && imgMaxWidth < minWidth) {
        imgMaxWidth = minWidth
    }

    if (isNumber(maxWidth) && imgMaxWidth > maxWidth) {
        imgMaxWidth = maxWidth
    }

    // 再根据有没有比例计算高
    if (isNumber(ratio)) {
        imgMaxHeight = imgMaxWidth / ratio

        if (imgMaxWidth !== imgMaxHeight) {
            const adjustedDimensions = adjustImageRatio({
                originalWidth: parseInt(imgMaxWidth, 10),
                originalHeight: parseInt(imgMaxHeight, 10),
                targetRatio: ratio,
            })

            imgMaxWidth = adjustedDimensions.width
            imgMaxHeight = adjustedDimensions.height
        }
    } else {
        // 计算缩放比例以适配maxWidth和maxHeight
        if (maxWidth && maxHeight) {
            const scaleByWidth = maxWidth / width
            const scaleByHeight = maxHeight / height
            const scale = Math.min(scaleByWidth, scaleByHeight)

            imgMaxWidth = width * scale
            imgMaxHeight = height * scale
        } else {
            imgMaxHeight = imgMaxWidth / (width / height) // 没固定比例就按照原来的图片比例来
        }
    }

    if (isNumber(minHeight) && imgMaxHeight < minHeight) {
        imgMaxHeight = minHeight
    }

    if (isNumber(maxHeight) && imgMaxHeight > maxHeight) {
        imgMaxHeight = maxHeight
    }

    // 有比例时，高度被 maxHeight 限制后需按比例重算宽度，再重新约束宽度范围
    if (isNumber(ratio)) {
        imgMaxWidth = imgMaxHeight * ratio
        if (isNumber(minWidth) && imgMaxWidth < minWidth) {
            imgMaxWidth = minWidth
        }
        if (isNumber(maxWidth) && imgMaxWidth > maxWidth) {
            imgMaxWidth = maxWidth
        }
        const adjustedDimensions = adjustImageRatio({
            originalWidth: parseInt(imgMaxWidth, 10),
            originalHeight: parseInt(imgMaxHeight, 10),
            targetRatio: ratio,
        })
        imgMaxWidth = adjustedDimensions.width
        imgMaxHeight = adjustedDimensions.height
    } else {
        // 无比例时，缩放后的宽度也可能低于 minWidth，需再次约束
        if (isNumber(minWidth) && imgMaxWidth < minWidth) {
            imgMaxWidth = minWidth
        }
        if (isNumber(maxWidth) && imgMaxWidth > maxWidth) {
            imgMaxWidth = maxWidth
        }
    }

    // 服务端限制
    if (imgMaxWidth > MAX_WIDTH_VALUE) {
        imgMaxWidth = MAX_WIDTH_VALUE
    }

    // 服务端限制
    if (imgMaxHeight > MAX_HEIGHT_VALUE) {
        imgMaxHeight = MAX_HEIGHT_VALUE
    }

    const styleType = `image/resize,m_pad,w_${parseInt(imgMaxWidth, 10)},h_${parseInt(imgMaxHeight, 10)},color_FFFFFF`

    return {
        styleType,
        repairUrl: url + '?x-oss-process=' + styleType,
        url,
    }
}
